import { baseApi } from "api/BaseApi";
import { Option } from "api/common/types/common.types";

import { ContractVehicle } from "./contractVehicle.types";

const VEHICLES_BASE_QUERY = "/settings/vehicles";

export const contractVehicleApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVehicles: builder.query<ContractVehicle[], void>({
      query: () => `${VEHICLES_BASE_QUERY}/`,
    }),
    getVehicleOptions: builder.query<Option[], void>({
      query: () => `${VEHICLES_BASE_QUERY}/`,
      transformResponse: (response: { results: ContractVehicle[] }) =>
        response.results.map((vehicle) => ({
          label: vehicle?.desig ? vehicle.desig : vehicle.vehicle,
          value: vehicle.veid,
        })),
    }),
  }),

  overrideExisting: false,
});

export const { useGetVehiclesQuery, useGetVehicleOptionsQuery } =
  contractVehicleApi;
